import React from 'react';
import { ArrowUpRight, Quote } from 'lucide-react';
import { Link } from 'react-router-dom';

const RealGuides = () => (
  <section className="relative overflow-hidden bg-[#160728] py-20 text-white sm:py-28">
    <div className="absolute -right-32 top-20 h-96 w-96 rounded-full bg-purple-700/25 blur-3xl" />
    <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:px-8">
      <div>
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.35em] text-yellow-300/80">
          The difference is real
        </p>
        <h2 className="mb-8 font-title text-4xl font-bold text-yellow-300 sm:text-5xl">
          Advanced Guides. Proven Power.
        </h2>
        <div className="space-y-5 text-lg leading-8 text-white/75">
          <p>
            Genuine spiritual power is rare in a crowded field of average energy workers, healers, and coaches. Most of our practitioners are trained through Mystic University, the leading metaphysical university in the world, in techniques and ways of working with power that live outside of books, courses, and search results. That level of training exists in a category of its own, and few practitioners anywhere can match it.
          </p>
          <p>
            Our practitioners heal what needs healing, shift stuck energy, and move mindsets, fast. This is real spiritual power, put to work for real results.
          </p>
        </div>
        <Link
          to="/practitioners"
          className="mt-9 inline-flex items-center gap-2 rounded-lg border border-yellow-300/50 px-6 py-3 text-sm font-semibold uppercase tracking-[0.16em] text-yellow-200 transition hover:bg-yellow-300/10"
        >
          Meet the practitioners <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>

      <blockquote className="relative rounded-3xl border border-yellow-200/20 bg-white/[0.06] p-7 shadow-2xl backdrop-blur-sm sm:p-10">
        <Quote className="mb-6 h-10 w-10 text-yellow-300/70" />
        <p className="font-title text-2xl leading-10 text-white sm:text-3xl">
          She listened to what I had to tell her and knew exactly where to go to remove the issue by the root. She led me through a powerful hypnosis, and the way she did it, I have never experienced before.
        </p>
        <footer className="mt-7 border-t border-white/15 pt-5 text-sm uppercase tracking-[0.14em] text-yellow-200/75">
          D.H. — Private 1 on 1 Session
        </footer>
      </blockquote>
    </div>
  </section>
);

export default RealGuides;